import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { AbcAutoCompleteInputComponent } from '@barthauer/abc/ui-components';
import { ResourceSet } from 'libs/abc/core/resources/src/lib/resource-set';
import { MapView } from '../../map.view';
declare var ol: any;

@Component({
    selector: 'map-scaletext',
    templateUrl: './map-scaletext.component.html',
    styleUrls: ['./map-scaletext.component.scss'],
    standalone: false
})
export class MapScaletextComponent implements OnInit {
  @ViewChild('scaleInputTrigger', { static: true }) scaleInputTrigger: MatMenuTrigger;
  @ViewChild('autoComplete', { static: true }) autoCompleteInput: AbcAutoCompleteInputComponent;

  // tslint:disable-next-line: member-ordering
  private mapView: MapView;
  scaleDisplayText: string = '';
  public res = ResourceSet.Empty;

  constructor(private resourceService: ResourceManagerService) {}

  async ngOnInit() {
    this.res = await this.resourceService.getResourceSet('abc-graphics-adapters-open-layers');
  }

  initMap(mapView: MapView, scales: number[]) {
    this.mapView = mapView;
    if (scales && scales.length) {
      this.autoCompleteInput.items = scales.map((_) => '1:' + _);
    } else {
      this.autoCompleteInput.items = [];
    }
  }

  buttonClick(e): void {
    this.autoCompleteInput.searchInputClick(e);
    this.autoCompleteInput.value = '1:';
  }

  getMapScale(): number {
    let ret: number;

    if (this.mapView) {
      ret = this.mapView.getCurrentScale();

      ret = Math.round(ret);
    }

    return ret;
  }

  applyScale(sScale: string) {
    setTimeout(() => this.scaleInputTrigger.closeMenu(), 0);
    if (this.mapView && sScale) {
      sScale = sScale.trim().replace('1:', '');
      if (!isNaN(sScale as any) && sScale !== '') {
        this.mapView.setCurrentScale(sScale as any);
      }
    }
    this.autoCompleteInput.closePanel();
  }
}
